export const apiConfig = {
    uri: "https://rrtoolsapi.azure-api.net/prod-stock-level"
};